import React from "react"

const StatusPin = ({ online = false, flat = false, type = "" }) => (
  <span
    key={type}
    className={`status-pin-kit-${type} status-pin ${
      online ? "online" : "offline"
    }${flat ? " flat" : ""}`}
  >
    <span className="dot" />
    <span className="stem" />
  </span>
)

export default StatusPin
